import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.scss',
})
export class DetailComponent {
  @Input() colourClass?: string;
  @Input() label?: string;
  @Input({ required: true }) value: number | string | null | undefined = null;

  get class(): string {
    const classes = ['badge'];

    if (this.colourClass) classes.push(this.colourClass);

    return classes.join(' ');
  }
}
